<template>
    <div>
        <div v-if="fetcher.loading">Laddar...</div>

        <create-contact-log :clinic="clinic" :types="types" :contact-logs="contact_logs" :prospect-portal-base-url="prospect_portal_base_url" :is-local="is_local" @created="onCreated"></create-contact-log>

        <div class="list-group" v-if="fetcher.initialized && !fetcher.loading">

            <log-row
                v-for="entry in contact_logs"
                :key="entry.id"
                :clinic="clinic"
                :entry="entry"
                @deleted="onDeleted"
                @updated="onUpdated">
            </log-row>

        </div>
    </div>
</template>

<script>

import fetcher from '../../../../shared/mixins/fetcher'
import CreateContactLog from './create.vue'
import LogRow from './log-row.vue'

export default {

    mixins: [
        fetcher
    ],

    components: {
        CreateContactLog,
        LogRow
    },

    props: {
        clinic: {
            required: true
        }
    },

    data () {
        return {
            contact_logs: [],
            types: {},
            prospect_portal_base_url: '',
            is_local: false,
            fetcher: {
                autoFill: ['contact_logs', 'types', 'prospect_portal_base_url', 'is_local']
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/clinics/' + this.clinic.id + '/contactLog'
        }
    },

    mounted () {
        bus.$on('refresh-data', this.fetcherFetch)
    },

    beforeDestroy () {
        bus.$off('refresh-data', this.fetcherFetch)
    },

    methods: {
        onCreated (data) {
            this.contact_logs = data.contact_logs
        },
        onDeleted (data) {
            this.contact_logs = data.contact_logs
        },
        onUpdated (data) {
            this.contact_logs = data.contact_logs
        }
    }

}
</script>
